export default {
  CLEAR: 'CLEAR',
  GET_WISHLIST: 'GET_WISHLIST',
  GET_WISHLIST_RESP: 'GET_WISHLIST_RESP',
  REMOVE_WISHLIST: 'REMOVE_WISHLIST',
  ADD_WISHLIST_ITEM: 'ADD_WISHLIST_ITEM',
};
